export default "__VITE_ASSET__U5YtDYeZ__"